import { render, staticRenderFns } from "./signup-overseas.vue?vue&type=template&id=1d7964ea&scoped=true"
import script from "./signup-overseas.vue?vue&type=script&lang=js"
export * from "./signup-overseas.vue?vue&type=script&lang=js"
import style0 from "./signup-overseas.vue?vue&type=style&index=0&id=1d7964ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7964ea",
  null
  
)

export default component.exports